"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BlueBaseContent = void 0;
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const react_native_1 = require("react-native");
const hooks_1 = require("../../hooks");
const utils_1 = require("../../utils");
const BlueBaseFilter_1 = require("../BlueBaseFilter");
/**
 * 🏡 BlueBaseContent
 * @param props
 */
const BlueBaseContent = (props) => {
    const { children, styles } = props;
    const BB = (0, hooks_1.useBlueBase)();
    const Navigation = (0, hooks_1.useComponent)('Navigation');
    const View = (0, hooks_1.useComponent)('View');
    const { theme } = (0, hooks_1.useTheme)();
    const intl = (0, hooks_1.useIntl)();
    return children ? ((0, utils_1.renderChildrenWithProps)(children, { BB })) : (<View key="bluebase-wrapper" style={styles.backdrop}>
			<react_native_1.StatusBar translucent barStyle={theme.mode === 'dark' ? 'light-content' : 'dark-content'}/>
			<BlueBaseFilter_1.BlueBaseFilter filter="bluebase.navigator.root" value={{}} args={{ theme, BB, intl }}>
				{(navigator) => <Navigation navigator={navigator}/>}
			</BlueBaseFilter_1.BlueBaseFilter>
		</View>);
};
exports.BlueBaseContent = BlueBaseContent;
exports.BlueBaseContent.defaultStyles = (theme) => ({
    backdrop: {
        backgroundColor: theme.palette.background.default,
        flex: 1,
    },
});
